import {
  AgentV2ConversationDetailSchema,
  AgentV2ConversationListResponseSchema,
  type AgentV2ConversationDetail,
  type AgentV2ConversationListResponse,
} from '@magimp/shared';
import { request } from '../client.js';

const BASE = '/dashboards/agent/v2/conversations';

export function listAgentV2Conversations(): Promise<AgentV2ConversationListResponse> {
  return request(BASE, { method: 'GET' }, {}, AgentV2ConversationListResponseSchema);
}

export function getAgentV2Conversation(id: string): Promise<AgentV2ConversationDetail> {
  return request(`${BASE}/${id}`, { method: 'GET' }, {}, AgentV2ConversationDetailSchema);
}

export function reopenAgentV2Conversation(id: string): Promise<AgentV2ConversationDetail> {
  return request(`${BASE}/${id}/reopen`, { method: 'POST' }, {}, AgentV2ConversationDetailSchema);
}
